// ABOUTME: Inline SVG Oleum logo icon for use as a React component.
// ABOUTME: Uses currentColor for stroke so it inherits text color from parent.

interface OleumIconProps {
  className?: string;
}

export function OleumIcon({ className }: OleumIconProps) {
  return (
    <svg
      viewBox="-1 -4 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Hexagon outline */}
      <path
        d="M12 2L21.5 7.5V16.5L12 22L2.5 16.5V7.5L12 2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      {/* Inner circle */}
      <circle
        cx="12"
        cy="12"
        r="3.5"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* Green 4-point sparkle at top-right */}
      <path
        d="M19 -3L21 2.6L27 5L21 7.4L19 13L17 7.4L11 5L17 2.6Z"
        fill="#34d399"
      />
    </svg>
  );
}
